import React, {Component} from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import {change, Field} from 'redux-form';
import {connect} from 'react-redux';
import {compose} from 'recompose';
import {RESOURCES as productResources} from '../fuseProductsResourceMap';
import {checkTokenStatus} from '../shared/tokenFunctions';
import VirtualizedSelectInput from '../components/VirtualizedSelectInput';

/**
 * A Virtualized SelectInput form component with Proto Product choices populated from Product Type value.
 *
 */
class ProductByTypeNameIdBrandDependentSelectInput extends Component {
    constructor(props) {
        super(props);

        this.state = {
            sourceParam: null,
            selectChoices: [],
            selectedId: null,
            selectedName: '',
        };

        this.handleSelectChange = this.handleSelectChange.bind(this);
    }

    componentDidMount() {
        // Set the dependentProp value and retrieve data
        this.setState({
            sourceParam: this.props[this.props['dependentProp']]
        });
        this.fetchData(this.props);
    }

    componentWillReceiveProps(nextProps) {
        // If dependentProp changes value, update the value
        const propName = this.props['dependentProp'];
        if (nextProps[propName] !== this.props[propName]) {
            this.setState({
                sourceParam: nextProps[propName],
                selectedId: null,
                selectedName: '',
            });
            this.props.dispatch(change('record-form', 'product', ''));
            this.props.dispatch(change('record-form', 'product_name', ''));
        }
    }

    componentDidUpdate(prevProps) {
        // If dependentProp value changes, retrieve data
        const propName = this.props['dependentProp'];
        if (prevProps[propName] !== this.props[propName]) {
            this.setState({
                selectChoices: []
            });
            this.fetchData(this.props);
        }
    }

    fetchData(props) {
        // Assemble the URI
        const params = {
            filter: {
                type: encodeURIComponent(props[props['dependentProp']])
            },
            pagination: {page: 1, perPage: 10000},
            sort: {field: "name", order: "ASC"}
        };
        const resource = productResources.Products.GET_LIST(params);

        // Retrieve the data and assign results to the Select choices
        import('../shared/functions')
            .then(functions => {
                const tokenStatus = checkTokenStatus(null);
                if (tokenStatus.expired) {
                    return;
                }
                axios({
                    method: 'get',
                    url: resource.uri,
                    headers: functions.getGetHeaders()
                }).then((result) => {
                    if (result.data.payload) {
                        let choices = this.assembleChoiceNames(result.data.payload);
                        this.setState({
                            selectChoices: choices
                        });
                    }
                }).catch((error) => {
                    if (error.response) {
                        // Server response outside 2xx
                        console.log(error.response.data);
                    } else if (error.request) {
                        // No response
                        console.log(error.request);
                    } else {
                        console.log('Error', error.message);
                    }
                });
            });
    }

    assembleChoiceNames(choices) {
        // Set select label: Name - ID - (Brand)
        for (let choice of choices) {
            const name = (choice.name) ? choice.name : '';
            const id = (choice.id) ? ' - ' + choice.id : '';
            const brand = (choice.brand) ? ' - ' + choice.brand : '';
            choice.display_name = name + id + brand;
        }
        return choices;
    }

    handleSelectChange(event, index) {
        const selectedId = index;
        // Retrieve the Product Name from the choices list based on the selected ID
        if (selectedId) {
            const product = this.state.selectChoices.find(p => p.id === selectedId);
            if (product) {
                this.setState({
                    selectedName: product.name
                });
                this.props.dispatch(change('record-form', 'product_name', product.name));
            }
        } else {
            this.setState({
                selectedName: ''
            });
            this.props.dispatch(change('record-form', 'product_name', ''));
        }
    }

    render() {
        const styles = {
            fullWidth: {width: '100%'},
            hidden: {display: 'none'},
        };
        return (
            <span>
                <Field name="product"
                       component={VirtualizedSelectInput}
                       choices={this.state.selectChoices}
                       optionText="display_name"
                       onChange={this.handleSelectChange}
                       label="Select a Product"
                       allowEmpty
                       options={{
                           className: "full-width",
                           clearable: false,
                           placeholder: "Select a Product",
                       }}
                />
                <br/>
                <Field name="product_name"
                       component="input"
                       type="text"
                       value={this.state.selectedName}
                       style={styles.hidden}
                />
            </span>
        );
    }
}

ProductByTypeNameIdBrandDependentSelectInput.propTypes = {
    addField: PropTypes.bool.isRequired,
    dependentProp: PropTypes.string,
    selectedId: PropTypes.string,
    selectedName: PropTypes.string,
};

ProductByTypeNameIdBrandDependentSelectInput.defaultProps = {
    addField: true,
    dependentProp: null,
    selectedId: null,
    selectedName: '',
};

const enhance = compose(
    connect()
);

export default enhance(ProductByTypeNameIdBrandDependentSelectInput);



// WEBPACK FOOTER //
// ./src/Fuse/components/ProductByTypeNameIdBrandDependentSelectInput.js